
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private dialog: MatDialog, private router: Router) { 

  }

  checkTokenExpiry() {
    const token = localStorage.getItem('token-admin');
    if (token) {
      
      const decodedToken: any = jwt_decode.jwtDecode(token); 

      const expiryTime = decodedToken.exp * 1000; 
      const currentTime = Date.now();

      if (expiryTime < currentTime ) {
        this.openTokenExpiredDialog();
        console.log('Token expired');
      } 
    
    } 
   
    else {
      console.error('Token not found or not expired');
    }
  }



  openTokenExpiredDialog() {
    Swal.fire({
      title: 'Token Expired',
      text: 'Please log in again',
      icon: 'warning',
      confirmButtonText: 'OK'
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('token-admin')
        this.router.navigate(['/auth-admin/login']);  
        }
    });
  }



}
